import { useState } from "react";

const FORM_SUBMIT_URL = "https://readdy.ai/api/form/d9squ194ne17ei0sdmeg";

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeyVal = (formData.get("phone_alt") as string || "").trim();
    if (honeyVal) {
      setStatus("success");
      setEmail("");
      return;
    }
    formData.delete("phone_alt");

    try {
      const res = await fetch(FORM_SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || "";
        if (serverMsg.includes("spam") || serverMsg.includes("form data is spam")) {
          setStatus("error");
          setErrorMsg(serverMsg);
        } else {
          setStatus("error");
          setErrorMsg(serverMsg || "订阅失败，请稍后再试");
        }
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络错误，请检查连接后重试");
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <img
          src="https://readdy.ai/api/search-image?query=subtle%20minimalist%20abstract%20pattern%20with%20warm%20cream%20and%20beige%20tones%20delicate%20geometric%20texture%20very%20light%20background%20texture&width=1800&height=600&seq=cta-bg-pattern&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
          免费订阅
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3"
          style={{ fontFamily: "var(--font-heading)" }}>
          每周获取最新Po文技巧
        </h2>
        <p className="text-foreground-600 text-sm mb-8 max-w-md mx-auto">
          订阅我们的电子报，每周收到精选的po文创作技巧、案例分析与行业趋势，让你的内容创作能力持续进化。
        </p>

        {status === "success" ? (
          <div className="bg-accent-100 text-accent-700 rounded-xl px-6 py-4 text-sm font-medium">
            感谢订阅！我们已将确认邮件发送到你的邮箱，请查收。
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="absolute opacity-0 pointer-events-none"
              style={{ position: "absolute", left: "-9999px" }}
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的电子邮箱"
              required
              className="flex-1 px-4 py-3 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="mt-3 text-sm text-red-500">{errorMsg}</p>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          我们尊重你的隐私，绝不发送垃圾邮件，你可以随时取消订阅。
        </p>
      </div>
    </section>
  );
}